export const dataLayer = async (currentUrl, pageName) => {
    if (pageName.includes('?')) {
        pageName = pageName.substring(0, pageName.lastIndexOf('?'));
    }

    let transaction_type = '';
    let page_title='';
    let transaction_step=null;
    let error_type=null;
    let error_text=null;

    if (pageName === 'applyMarketingPreferences') {
        page_title='Marketing Preferences';
        transaction_type = 'Marketing Preferences';
        transaction_step='4';
    } else if (pageName === 'confirmation') {
        page_title='Confirmation';
        transaction_type = 'confirmation';
        transaction_step='6';
    } else if (pageName === '') {
        page_title='Before you start';
        transaction_type = 'Before you start';
        transaction_step='1';
    } else if (pageName === 'eligibilityCheck') {
        page_title='Eligibility Check';
        transaction_type = 'Eligibility Check';
        transaction_step='2';
    } else if (pageName === 'review') {
        page_title='Review';
        transaction_type = 'Review and submit';
        transaction_step='5';
    } else if (pageName === 'selectedCard') {
        page_title='Select Card';
        transaction_type = 'Select Card';
        transaction_step='3';
    } else if (pageName === 'cancelCard') {
        page_title='Cancel Card';
        transaction_type = 'Cancel Senior Savers Card';
    } else if (pageName === 'marketingPreferences') {
        page_title='Manage Marketing Preferences';
        transaction_type = 'Manage marketing preferences';
    } else if (pageName === 'replaceCard') {
        page_title='Replace Card';
        transaction_type = 'Replace Senior Savers Card';
    } else if (pageName === 'convertCard') {
        page_title='Convert Card';
        transaction_type = 'Convert to Seniors Card';
    } else if (pageName === 'currentCardStatus') {
        page_title='Link-Current Card Status';
        transaction_type = 'Link-Current Card Status';
    }else if (pageName === 'validateCard') {
        page_title='Link-validate card number';
        transaction_type = 'Link-validate card number';
     } else if (pageName === 'applicationError') {
        page_title='Application Error';
        error_text = 'Server error';
        error_type='server error';
    } else if (pageName === 'linkingError') {
        page_title='Linking Error';
        error_text = 'Link error';
        error_type='link error';
    } else if (pageName === 'ageError') {
        page_title= 'Age Error';
        error_text = 'Age eligibility error';
        error_type='validation error';
    }else if (pageName === 'addressError') {
        page_title='Address Error';
        error_text = 'Non australian address error';
        error_type='validation error';
    }else if (pageName === 'cardError') {
        page_title='Card Error';
        error_text = 'Card exist error';
        error_type='validation error';
    }else if (pageName === 'residencyError') {
        page_title= 'Residency Error';
        error_text = 'AUS residency not proven error';
        error_type='validation error';
    }

    else {
        page_title=pageName;
        transaction_type = pageName;
    }

    window.dataLayer.push({
        'event': 'v_page_info',
        'page_info': {
            'page_location': currentUrl,
            'agency': 'DCJ-SENIORS',
            'page_title': page_title,
        },
        'transaction_info': {
            'transaction_name': 'seniors card',
            'transaction_step': transaction_step,
            'transaction_type': transaction_type,
            'transaction_id': null,
        },
        'user_info': {
            'user_id': null,
            'user_login_status': 'fully authenticated'
        },
        'error_type': error_type,
        'error_text': error_text,
    });
};

